import React from 'react';
import _ from '../../i18n.jsx';
import FormComponent from '../FormComponent.jsx';
import style from './data.of.birth.less';
import DontKnowBtn from '../dont.know.btn/dont.know.btn.jsx';
import DropDown from '../dropdown/dropdown.jsx';
import TextInput from '../text.input/text.input.jsx';
import moment from 'moment';
import classNames from 'classnames';
import { isInRangeEq } from '../../../common/utils.jsx';
import { compareObjectsInclusive } from '../../../common/utils.jsx';
import { EMPTY_STRING } from '../../questionnaire.utils.jsx';

const UNKNOWN = 'UNKNOWN';
const CURRENT_YEAR = moment().year();
export default class DateOfBirth extends FormComponent {
    constructor() {
        super();
        this.onDOBChangeHandler = this.onDOBChangeHandler.bind(this);
    }
    shouldComponentUpdate(nextProps) {
        const propsList = [ 'value', 'disabled', 'id', 'name', 'placeholder', 'length', 'unknownAccepted' ];
        return compareObjectsInclusive(this.props, nextProps, propsList);
    }
    static parseDate(dateOrAge) {
        const FULL_DATE_ARRAY_LENGTH = 3; // 3 for each date component - day, month, year
        const AGE = 0;
        //As we writing this date not into XML, we can use ISO, not mm/dd/yyyy format
        const YEAR = 0;
        const MONTH = 1;
        const DAY = 2;
        const dateArray = dateOrAge.toString().split('-').map((value) => (parseInt(value) || EMPTY_STRING));
        if (FULL_DATE_ARRAY_LENGTH === dateArray.length) {
            return {
                age: DateOfBirth.calculateAge(dateOrAge),
                day: dateArray[DAY],
                month: dateArray[MONTH],
                year: dateArray[YEAR]
            };
        }
        return {
            age: dateArray[AGE] || EMPTY_STRING,
            day: EMPTY_STRING,
            month: EMPTY_STRING,
            year: EMPTY_STRING
        };
    }
    static calculateAge(dateString) {
        const ISO_DATE_RE = /^\d{4}-\d{1,2}-\d{1,2}$/;
        const dateArray = dateString.split('-').map((value) => (parseInt(value) || EMPTY_STRING));
        const [ year, month, day ] = dateArray;
        if (ISO_DATE_RE.test(dateString) && DateOfBirth.validateYear(day, month, year)) {
            /*
            * Still this code
            * `moment().diff(dateString, 'years');`
            * returns NaN in firefox we use another one
            * */
            return moment().diff(moment(dateString, 'YYYY-MM-DD'), 'years');
        }
        return EMPTY_STRING;
    }
    static isLeapYear(year) { return ((0 === year % 4) && (0 !== year % 100)) || (0 === year % 400); }
    static getAge(ageString) { return moment().diff(ageString, 'years'); }
    static _getNameAndValue() {
        if (arguments[0].target) {
            const event = arguments[0];
            return {
                name: event.target.name,
                value: event.target.value
            };
        }
        return {
            name: arguments[0],
            value: arguments[1]
        };
    }
    static validateDay(day, month, year = CURRENT_YEAR) {
        let isValidDay = true;
        const isLeapYear = DateOfBirth.isLeapYear(year);
        const leapFebruaryDays = 29;
        const februaryIndex = 2;
        const MONTHS = DateOfBirth.MONTHS;
        const monthIndex = MONTHS.findIndex((currentMonth) => currentMonth.value === month);
        if (februaryIndex === month && isLeapYear) { return leapFebruaryDays >= day; }
        if (month) { isValidDay = day <= MONTHS[monthIndex].lastDay; }
        return isValidDay;
    }
    static validateYear(day, month, year) {
        let isValidYear = true;
        const isValidDay = DateOfBirth.validateDay(day, month, year);
        if (year) { isValidYear = isValidDay && isInRangeEq(year, DateOfBirth.MIN_YEAR_VALUE, CURRENT_YEAR); }
        return isValidYear;
    }
    onDOBChangeHandler() {
        const parsedDate = DateOfBirth.parseDate(this.props.value);
        const { name, value } = DateOfBirth._getNameAndValue(...arguments);
        if ('age' === name) { return this.onChangeHandler(value.toString()); }
        if (UNKNOWN === name) { return this.onChangeHandler(UNKNOWN); }
        parsedDate[name] = value;
        const { day, month, year } = parsedDate;
        this.onChangeHandler(`${year}-${month}-${day}`);
    }
    render() {
        const STRING = DateOfBirth.STRINGS;
        const { cssDropdownClass, disabled } = this.props;
        const { age, day, month, year } = DateOfBirth.parseDate(this.props.value);
        const isValidDay = DateOfBirth.validateDay(day, month);
        const isValidYear = DateOfBirth.validateYear(day, month, year);
        const dayInputClassName = classNames(style.input, style.day, { [style.error]: !isValidDay });
        const yearInputClassName = classNames(style.input, style.year, { [style.error]: !isValidYear });
        return (
            <div className={style.fieldWrapper}>
                <div className={style.inputWrapper}>
                    <TextInput disabled={disabled} type="text" name="age" placeholder={STRING.AGE} cssClass={classNames(style.input, style.age)}
                               onlyNumbers={true} length="3" value={age} onChangeCallback={this.onDOBChangeHandler}/>
                </div>
                <div className={style.inputWrapper}>
                    <span className={style.or}>
                        { STRING.OR }
                    </span>
                </div>
                <div className={style.inputWrapper}>
                    <TextInput disabled={disabled} type="text" name="day" placeholder={STRING.DAY}  cssClass={dayInputClassName}
                               onlyNumbers={true} value={day} length="2" onChangeCallback={this.onDOBChangeHandler}/>
                </div>
                <div className={style.inputWrapper}>
                    <DropDown disabled={disabled} cssDropdownClass={cssDropdownClass} name="month" placeholder={DateOfBirth.STRINGS.MONTH}
                        options={DateOfBirth.MONTHS} value={month} onChangeCallback={this.onDOBChangeHandler}/>
                </div>
                <div className={style.inputWrapper}>
                    <TextInput disabled={disabled} name="year" type="text" placeholder={STRING.YEAR}  cssClass={yearInputClassName}
                               onlyNumbers={true} value={year} length="4" onChangeCallback={this.onDOBChangeHandler}/>
                </div>
                <DontKnowBtn disabled={disabled} checked={UNKNOWN === this.props.value} value={UNKNOWN} onChangeCallback={this.onDOBChangeHandler}/>
            </div>
        );
    }
}
DateOfBirth.defaultProps = {
    value: EMPTY_STRING
};
DateOfBirth.MIN_YEAR_VALUE = 1000;
DateOfBirth.STRINGS = {
    OR: _(`or`),
    AGE: _(`age`),
    DAY: _(`day`),
    MONTH: _(`month`),
    YEAR: _(`year`)
};

DateOfBirth.MONTHS = [
    { name: _(`January`),   value: 1,    lastDay: 31 },
    { name: _(`February`),  value: 2,    lastDay: 28 },

    { name: _(`March`),     value: 3,    lastDay: 31 },
    { name: _(`April`),     value: 4,    lastDay: 30 },
    { name: _(`May`),       value: 5,    lastDay: 31 },

    { name: _(`June`),      value: 6,    lastDay: 30 },
    { name: _(`July`),      value: 7,    lastDay: 31 },
    { name: _(`August`),    value: 8,    lastDay: 31 },

    { name: _(`September`), value: 9,    lastDay: 30 },
    { name: _(`October`),   value: 10,   lastDay: 31 },
    { name: _(`November`),  value: 11,   lastDay: 30 },

    { name: _(`December`),  value: 12,   lastDay: 31 }
];

